import React from 'react';
import NavbarContent from './components/NavbarContent';
import styles from './Navbar.module.css';

const Navbar = () => {
    return (
        <div className={styles.navbarContainer}>
            <header className={styles.navbarHeader}>
                <section className={styles.navbarSection}>
                    <div className={styles.navbarBackground}>
                        <div className={styles.navbarOverlay}></div>
                        <div className={styles.navbarContentWrapper}></div>
                    </div>
                    <NavbarContent />
                </section>
            </header>
        </div>
    );
};

export default Navbar;
